import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'
import { keyframes } from '@emotion/react'

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

export const HeaderItem = styled('div')`
  h1 {
    margin: 0;
    font-family: ${theme.typography.family.bold};
    color: ${theme.colors.neutral.black};
  }
`

export const Wrapper = styled('div')`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: ${theme.spacing.lg} 0;
`
export const IconDiv = styled('div')`
  animation: ${spin} 2s linear infinite;
`
type ActionButtonProps = {
  fullfill: boolean
  disabled?: boolean
  sapButton?: boolean
  globalLoading?: boolean
}

export const ActionButton = styled.button<ActionButtonProps>`
  background: ${({ disabled, fullfill }) =>
    fullfill
      ? disabled
        ? theme.colors.neutral.clear
        : theme.colors.primary.main
      : theme.colors.neutral.white};

  color: ${({ disabled, fullfill }) =>
    fullfill
      ? disabled
        ? theme.colors.neutral.lighthover
        : theme.colors.neutral.white
      : disabled
      ? theme.colors.neutral.lighthover
      : theme.colors.primary.main};
  border-radius: ${theme.shapes.borderRadius.sm};
  border: 0;
  font-weight: ${theme.typography.weight.lg};
  font-family: ${theme.typography.family.primary};
  font-size: ${theme.typography.sizes['3xs']};
  padding: ${theme.spacing.xm};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${theme.spacing.xs};
  transition: all 0.3s ease-in-out;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  & + button {
    margin-left: ${theme.spacing.sm};
  }

  :hover {
    filter: ${({ disabled }) => (disabled ? 'none' : 'brightness(90%)')};
  }
  ${({ sapButton }) => sapButton && `color: ${theme.colors.neutral.white}`}

  cursor: ${({ globalLoading }) => (!globalLoading ? 'pointer' : 'wait')};
`

export const NdCard = styled.div`
  background-color: ${theme.colors.neutral.white};
  border-radius: ${theme.shapes.borderRadius.md};
`
